import { createFilterOptions } from '@mui/material';

export const INITIAL_SELECTED_TASK = {
  id: 0,
  taskName: '',
  startDate: null,
  endDate: null,
  description: null,
  status: '',
  plannedHours: 0,
  taskType: '',
  parentTaskId: null,
  createdAt: '',
  updatedAt: '',
  projectId: 0,
  userId: 0,
  projects: {
    id: 0,
    projectName: '',
    totalHrs: 0,
    allowOverSpent: 0,
    allowManualTask: 0,
    status: '',
    description: '',
    createdAt: '',
    updatedAt: '',
    clientId: 0,
    clients: {
      id: 0,
      clientName: '',
      createdAt: '',
      updatedAt: '',
      companyId: 0,
    },
  },
};

export const INITIAL_DIALOG_STATE = {
  title: '',
  plannedHours: '',
  project: null,
  section: null,
  taskType: 'Task',
  issueType: '',
  parentTaskId: '',
  startDate: null,
  endDate: null,
};

const filter = createFilterOptions();

const filterOptions = (options, params) => {
  const filtered = filter(options, params);
  if (params.inputValue !== '') {
    filtered.push({
      inputValue: params.inputValue,
      taskName: params.inputValue,
      projects: { projectName: 'Add Task' },
    });
  }
  return filtered;
};

export const taskSelectorOptions = {
  fullWidth: true,
  selectOnFocus: true,
  clearOnBlur: true,
  handleHomeEndKeys: true,
  freeSolo: true,
  disableClearable: true,
  groupBy: (option) => option?.projects?.projectName,
  getOptionLabel: (option) => option?.taskName,
  isOptionEqualToValue: (option, value) => option.id === value.id,
  filterOptions,
};
